import "./StoryHero.css";
import { FaArrowDown } from "react-icons/fa";

const StoryHero = () => {
  return (
    <section
      className="story-hero"
      style={{
        backgroundImage: `url(/assets/story/story-hero.webp)`,
      }}
    >
      <div className="story-overlay">
        <span className="story-subtitle">OUR STORY</span>

        <h1>
          Woven With Heritage,
          <br />
          Crafted For Generations
        </h1>

        <p>
          Discover the timeless legacy of handwoven artistry,
          where every saree reflects tradition, elegance,
          and the dedication of skilled artisans.
        </p>

        <div className="scroll-down">
          <FaArrowDown />
        </div>
      </div>
    </section>
  );
};

export default StoryHero;